module.exports = __webpack_public_path__ + "assets/img/email_icon.76bad5c0.png";